import { CalendarEvent } from "components/Calendar/types";
import moment from "moment-timezone";

export function buildEventGroupsByDate(events: CalendarEvent[], timezone: string) {
  const sorted = [...events].sort((a, b) => moment.tz(a.start, timezone).valueOf() - moment.tz(b.start, timezone).valueOf());

  const eventMap = new Map<string, Map<string, CalendarEvent[]>>();
  sorted.forEach((e) => {
    let dateKey;
    const { eventType = "event" } = e;

    if (e.start) {
      dateKey = moment.tz(e.start, timezone).format("YYYY-MM-DD");
    } else {
      dateKey = "unknown";
    }

    if (!eventMap.has(dateKey)) {
      eventMap.set(dateKey, new Map<string, CalendarEvent[]>());
    }

    const dateGroup = eventMap.get(dateKey)!;
    if (!dateGroup.has(eventType)) {
      dateGroup.set(eventType, []);
    }

    dateGroup.get(eventType)!.push(e);
  });

  return eventMap;
}
